import { useAmpLibraryFileQuery } from "src/graphql";
import { CreateCampaignMenuItem } from "src/pages/projects/library/canvas/create-campaign-menu-item";
import type { CreateCampaignTarget } from "src/pages/projects/library/canvas/use-create-campaign";
import type { ProjectAttachment } from "src/pages/projects/project-attachments";

type Props = {
  attachment: ProjectAttachment;
  onCreate: (target: CreateCampaignTarget) => void;
};

/**
 * Creates a campaign from an email attachment's own menu. A menu mounts its items only while it is
 * open, so the email's file loads when someone looks, not for every row.
 */
export const EmailCampaignMenuItem = ({ attachment, onCreate }: Props) => {
  const { link } = attachment;
  const fileId = link.amp_file?.content_email ? link.amp_file.id : undefined;
  const { data: file } = useAmpLibraryFileQuery(
    { id: fileId ?? "" },
    { enabled: Boolean(fileId), select: (data) => data.ampFile },
  );
  if (!file) return null;
  return (
    <CreateCampaignMenuItem
      file={file}
      isMenuOpen
      label="Create email campaign"
      onCreate={onCreate}
    />
  );
};
